<ng-container *ngIf="!isUserLoggedin && !landingPage">
    <app-guest-home></app-guest-home>
</ng-container>
<ng-container *ngIf="isUserLoggedin">
    <app-loggedin-home></app-loggedin-home>
</ng-container>

<ng-container *ngIf="!isUserLoggedin && landingPage">
    <app-static-pages (closeLandingPage)="closeLandingPage($event)" [url]="'landing_page'"></app-static-pages>
</ng-container>